import { render, staticRenderFns } from "./RiskEquipTable.vue?vue&type=template&id=03b8066d"
import script from "./RiskEquipTable.vue?vue&type=script&lang=js"
export * from "./RiskEquipTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports